import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function LoginPage() {
  const { login } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    const r = await login(email, password);
    setLoading(false);
    if (!r.ok) { setError(r.error); return; }
    toast.success(`Welcome back, ${r.user.name}`);
    const target = loc.state?.from ||
      (r.user.role === "admin" ? "/admin" : r.user.role === "trainer" ? "/trainer" : "/dashboard");
    nav(target);
  };

  return (
    <div className="container-fl py-16 max-w-md">
      <h1 className="text-3xl font-black tracking-tighter mb-2">Welcome back</h1>
      <p className="text-neutral-500 text-sm mb-8">Log in to your FitLink account.</p>
      <form onSubmit={submit} className="space-y-4" data-testid="login-form">
        <div>
          <label className="text-xs font-bold uppercase tracking-widest text-neutral-500">Email</label>
          <input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                 className="mt-1 h-12 w-full rounded-md border border-neutral-200 px-3 outline-none focus:border-neutral-900"/>
        </div>
        <div>
          <label className="text-xs font-bold uppercase tracking-widest text-neutral-500">Password</label>
          <input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
                 className="mt-1 h-12 w-full rounded-md border border-neutral-200 px-3 outline-none focus:border-neutral-900"/>
        </div>
        {error && <div data-testid="login-error" className="text-sm text-red-600">{error}</div>}
        <button data-testid="login-submit" type="submit" disabled={loading} className="btn-primary w-full">
          {loading ? "Logging in…" : "Log in"}
        </button>
      </form>
      <div className="flex items-center justify-between text-sm text-neutral-500 mt-6">
        <Link to="/forgot-password" data-testid="forgot-password-link" className="text-emerald-700 font-semibold">
          Forgot password?
        </Link>
        <span>
          No account?{" "}
          <Link to="/signup" className="text-emerald-700 font-semibold">Sign up</Link>
        </span>
      </div>
    </div>
  );
}
